<b3-modal
  #rejectStartModal
  [open]="open"
  overlay
  size="sm"
  (b3-close)="onModalDismiss()">
  <b3-modal-header
    heading="Rejeitar"
    aria-level="2"
    icon="cancel"
    icon-tone="danger"
    close-aria-label="Fechar">
  </b3-modal-header>

  <b3-modal-body>
    <div class="project-validation-reject-modal__body">
      <div role="radiogroup" aria-label="Ação de rejeição">
        <b3-radio-button
          name="project-validation-reject-action"
          value="correction"
          label="Solicitar correção"
          [selected]="true"
          disabled>
        </b3-radio-button>
      </div>

      <b3-input-text
        inputId="project-validation-reject-project-name"
        label="Nome do projeto"
        background="grey"
        [(ngModel)]="projectNameValue"
        [disabled]="true">
      </b3-input-text>

      <b3-input-area
        inputId="project-validation-reject-comment"
        label="Comentário"
        background="grey"
        placeholder="Inserir comentário"
        [(ngModel)]="comment"
        (ngModelChange)="onCommentChange($event)"
        [maxlength]="commentMaxLength">
      </b3-input-area>
    </div>
  </b3-modal-body>

  <b3-modal-footer>
    <div class="project-validation-reject-modal__footer">
      <b3-button
        type="button"
        variant="outlined"
        tone="default"
        (b3-click)="onCancel()">
        <b3-icon name="cancel" size="md"></b3-icon>
        Cancelar
      </b3-button>
      <b3-button
        type="button"
        variant="filled"
        tone="danger"
        [disabled]="!canConfirm"
        (b3-click)="onConfirm()">
        <b3-icon name="check_circle" size="md" tone="on-brand"></b3-icon>
        Confirmar
      </b3-button>
    </div>
  </b3-modal-footer>
</b3-modal>
